export default {
      id: "areas-5-usage",
      viewBox: "0 0 25 25",
      url: "/" + "assets/sprite.svg#areas-5",
      toString: function () {
        return this.url;
      }
    }